/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { styled } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view';

export const StyledProjectTreeItem = styled(TreeItem)(({ theme }) => ({
  [`& .${treeItemClasses.expanded}`]: {
    backgroundColor: `${theme.palette.tertiary.main}20`,
    [`& .${treeItemClasses.label}`]: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    '&:hover': {
      backgroundColor: `${theme.palette.tertiary.main}30`,
    },
  },
  [`& .${treeItemClasses.content}`]: {
    padding: 0,
  },
  [`& .${treeItemClasses.focused}`]: {
    backgroundColor: `${theme.palette.tertiary.main}20`,
  },
  [`& .${treeItemClasses.label}`]: {
    padding: '10px 10px 10px 54px',
    position: 'relative',
    borderRadius: '6px',
  },
  [`& .${treeItemClasses.iconContainer}`]: {
    display: 'none',
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    position: 'relative',
    overflow: 'hidden',
    marginLeft: 24,
    paddingLeft: 17,
    marginTop: '8px',
    '&:before': {
      content: "''",
      position: 'absolute',
      display: 'block',
      width: '1px',
      height: '100%',
      background: '#F6F7F8',
      left: 0,
    },
  },
}));

export const createProjectTreeItemStyles = makeStyles(() => ({
  iconRoot: {
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    position: 'absolute',
    overflow: 'hidden',
    top: '50%',
    left: '14px',
    transform: 'translateY(-50%)',
    '& svg': {
      width: '100%',
      height: '100%',
    },
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
}));
